import {useEffect, useState} from 'react';
import {
    addFavorite,
    removeFavorite,
    isFavorite,
    getFavorites,
    validateFavorites
} from './cookie-utils';

export default function useFavorites(events, setEvents) {
    const [favorites, setFavorites] = useState([]);

    const syncFavoritesWithEvents = (favoriteIds) => {
        setEvents((prevEvents) =>
            prevEvents.map((ev) => ({
                ...ev,
                isFavorite: favoriteIds.includes(ev.id),
            }))
        );
    };

    const loadFavorites = async () => {
        const ids = getFavorites();
        if (ids.length === 0) {
            setFavorites([]);
            syncFavoritesWithEvents([]);
            return;
        }

        try {
            const validEvents = await validateFavorites();
            const validIds = validEvents.map(e => e.id);

            setFavorites(validEvents);
            syncFavoritesWithEvents(validIds);
        } catch (error) {
            console.error('Błąd podczas walidacji ulubionych wydarzeń:', error);
        }
    };

    const toggleFavorite = (eventId, isNowFavorite) => {
        if (isNowFavorite) {
            addFavorite(eventId);
        } else {
            removeFavorite(eventId);
        }

        setEvents((prevEvents) =>
            prevEvents.map((ev) =>
                ev.id === eventId ? {...ev, isFavorite: isNowFavorite} : ev
            )
        );

        loadFavorites();
    };

    useEffect(() => {
        loadFavorites();
    }, []);

    return {
        favorites,
        toggleFavorite,
        reloadFavorites: loadFavorites,
    };
}
